import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthGuard } from '../../../../app/auth/helpers/auth.guards';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from '../../../../app/layout/components/content-header/content-header.module';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { AccountSettingsComponent } from '../../../../app/main/pages/account-settings/account-settings.component';
import { AccountSettingsService } from '../../../../app/main/pages/account-settings/account-settings.service';

import { CoreSidebarModule } from '@core/components';

import { NewUserSidebarComponent } from '../../../../app/main/pages/account-settings/new-user-sidebar/new-user-sidebar.component';
import { EditUserSidebarComponent } from '../../../../app/main/pages/account-settings/edit-user-sidebar/edit-user-sidebar.component';
import { LocationSidebarComponent } from './location-sidebar/location-sidebar.component';

import { ProductSidebarComponent } from '../../../../app/main/pages/account-settings/product-sidebar/product-sidebar.component';

import { TemplateSidebarComponent } from './template-sidebar/template-sidebar.component';

import { ProductItemComponent } from '../../../../app/main/pages/account-settings/product-item/product-item.component';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';

import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { NavbarInviteComponent } from '../../../../app/layout/components/navbar/navbar-invite/navbar-invite.component';
import { CouponSidebarComponent } from '../../../../app/main/pages/account-settings/coupon-sidebar/coupon-sidebar.component';

import { QuillModule } from 'ngx-quill';
import { NgxMaskModule } from 'ngx-mask';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PaymentMethodComponent } from '../../../../app/main/shared-resources/payment-method/payment-method.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  observer: true
};


const routes: Routes = [
  {
    path: 'account-settings',
    component: AccountSettingsComponent,
    canActivate: [AuthGuard],
    resolve: {
      accountSetting: AccountSettingsService
    },
    data: { animation: 'account-settings' }
  }
];

@NgModule({
  declarations: [
    AccountSettingsComponent, 
    NewUserSidebarComponent, 
    EditUserSidebarComponent, 
    LocationSidebarComponent, 
    TemplateSidebarComponent,
    ProductItemComponent, 
    ProductSidebarComponent,
    CouponSidebarComponent, 
    PaymentMethodComponent
  ],
    
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    CoreCommonModule,
    ContentHeaderModule,
    Ng2FlatpickrModule,
    CoreSidebarModule,
    NgSelectModule,
    CoreTouchspinModule,
    QuillModule.forRoot(),
    NgbDropdownModule,
    NgxMaskModule.forRoot(),
    ImageCropperModule
  ],

  providers: [AccountSettingsService, 
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }]
})
export class AccountSettingsModule {}
